<template>
  <a-modal title="编辑中文品名" :visible="visible" width="1000px" :confirm-loading="confirmLoading" @ok="handleOk"
    @cancel="handleCancel" class="edit-product-categoryZh" :rowKey="(record) => record.productSku">
    <div style="text-align: left;">
      <a-button type="primary" @click="handleOneClickFill">
        一键填充中文品名
      </a-button>
      <a-button type="primary" @click="handleOneClickDelete()" style="margin-left:6px;">
        一键删除中文品名
      </a-button>
    </div>
    <a-table :columns="columns" :data-source="currentRecordList" style="margin-top: 10px" bordered :scroll="{ y: 550 }"
      :pagination="false">
      <template #productSku="text, record">
        <a @click="skuLink(record, 1)">{{ text }}</a>
        <a-tag v-if="record.fillStatus" color="blue">已填充</a-tag>
      </template>
      <template #productSkuImg="text, record">
        <el-image :src="record.productImg" :preview-src-list="[record.productImg]"
          style="width:50px;height:50px"></el-image>
      </template>
      <template slot="productItemCategoryZh" slot-scope="text, record">
        <a-select v-model="record.productItemCategoryZh" style="width: 220px;" allowClear show-search
          :dropdownStyle="{ zIndex: 4002 }">
          <a-select-option v-for="item in productCategoryZhList" :key="item.productItemCategoryZh"
            :value="item.productItemCategoryZh">
            <a-tooltip placement="top" :title="item.productItemCategoryZh">
              {{ item.productItemCategoryZh }}
            </a-tooltip>
          </a-select-option>
        </a-select>
      </template>
      <template #productSellPrice="text, record">
        <div>
          {{ record.productPrice }}
        </div>
      </template>
    </a-table>
    <a-table :columns="columns" :data-source="excludeProductSkuList" style="margin-top: 10px" bordered
      :scroll="{ y: 550 }" :pagination="pagination" @change="changePage">
      <template #productSellPrice="text">
        <div>
          {{ text }}
        </div>
      </template>
      <template #productSku="text, record">
        <a @click="skuLink(record, 1)">{{ text }}</a>
      </template>
      <template #productSkuImg="text, record">
        <el-image :src="record.productSkuImg" :preview-src-list="[record.productSkuImg]"
          style="width:50px;height:50px"></el-image>
      </template>
      <template slot="productItemCategoryZh" slot-scope="text, record">
        <a-select v-model="record.productItemCategoryZh" style="width: 220px;" allowClear show-search :dropdownStyle="{ zIndex: 4002 }">
          <a-select-option v-for="item in productCategoryZhList" :key="item.productItemCategoryZh"
            :value="item.productItemCategoryZh">
            <a-tooltip placement="top" :title="item.productItemCategoryZh">
              {{ item.productItemCategoryZh }}
            </a-tooltip>
          </a-select-option>
        </a-select>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { message, Modal, Select, Table, Button, Tooltip } from "ant-design-vue";
import { supplierManageQueryApi, batchUpdateProductItemCategoryZhApi, customsListApi, } from "@/apis/outStock";
export default {
  name: "EditProducCategoryZh",
  components: {
    [Modal.name]: Modal,
    [Select.name]: Select,
    [Select.Option.name]: Select.Option,
    [Table.name]: Table,
    [Select.name]: Select,
    [Select.Option.name]: Select.Option,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip
  },
  data() {
    return {
      errorImgSrc: require('@/assets/imgError.png'),
      visible: false,
      confirmLoading: false,
      /** 当前行数据 */
      currentRecordList: [],
      /** 排除当前行数据 */
      excludeProductSkuList: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 100,
        showTotal: total => `共有 ${total} 条记录`
      },
      pageParams: {
        pageSize: 100,
        pageNum: 1,
      },
      columns: [
        {
          title: "商品sku",
          dataIndex: "productSku",
          scopedSlots: { customRender: "productSku" },
        },
        {
          title: "商品属性",
          dataIndex: "productPropertiesName",
        },
        {
          title: "参考单价(元)",
          dataIndex: "productSellPrice",
          scopedSlots: { customRender: "productSellPrice" },
        },
        {
          title: "商品采购图片",
          dataIndex: "productSkuImg",
          scopedSlots: { customRender: "productSkuImg" },
        },
        {
          title: "中文品名",
          width: 260,
          dataIndex: "productItemCategoryZh",
          scopedSlots: { customRender: "productItemCategoryZh" },
        },
      ],
      productCategoryZhList: [],
      type: 1,
      item: {}
    };
  },

  methods: {
    changePage(pagination) {
      this.pagination.current = pagination.current
    },
    skuLink(record, type) {
      if (type == 1) {
        window.open(record.product.productDetailUrl, "_blank");
      }
    },
    async open(record, type) {
      console.log(record)
      this.item = record
      this.visible = true;
      this.type = type
      this.currentRecordList = [{ ...record }]
      // 获取所有sku数据
      const { list, totalCount } = await this.getTotalSkuList(record)
      console.log(list, totalCount)
      this.excludeProductSkuList = list;
      /** 获取中文品名列表 */
      const { data: categoryList } = await customsListApi({});
      this.productCategoryZhList = categoryList;
      this.pagination.total = Number(totalCount);
    },
    async getTotalSkuList(record) {
      const resData = await supplierManageQueryApi({
        excludeProductSku: record.productSku,
        productCode: record.productCode,
        channel: record.channel,
        ...this.pageParams,
      });
      const { list, totalPage, totalCount } = resData.data
      const apis = []
      for (let i = 2; i <= totalPage; i++) {
        apis.push(supplierManageQueryApi({
          excludeProductSku: record.productSku,
          productCode: record.productCode,
          channel: record.channel,
          ...this.pageParams,
          pageNum: i
        }))
      }
      const data = await Promise.all(apis)
      let totalList = [...list]
      console.log(data)
      data.forEach((item) => {
        totalList = [
          ...totalList,
          ...(item.data?.list ?? [])
        ]
      })
      return {
        list: totalList,
        totalPage,
        totalCount
      }
    },
    /** 一键填充中文品名 */
    handleOneClickFill() {
      /** 获取所有数据 */
      const allData = [...this.currentRecordList, ...this.excludeProductSkuList]
      /** 已填充的中文品名信息 */
      const target = allData.find(item => item.productItemCategoryZh)
      /** 获取当前已填充的所有中文品名 */
      const filterAllData = allData.filter(item => item.productItemCategoryZh)
      /** 
      * 判断是否已经存在中文品名
      * 少于2个的中文品名，则可一键填充
      *  */
      if (filterAllData && filterAllData.length >= 2) {
        // return message.warning(`无法一键填充, ${filterAllData.map(item => item.productSku).join(',') }\n\n sku已经存在中文品名信息`)
        return this.$message.warning(`无法一键填充, 所有sku已经存在中文品名信息`)
      }
      if (target) {
        /** 填充当前行的中文品名 */
        if (!this.currentRecordList[0].productItemCategoryZh) {
          this.currentRecordList[0].productItemCategoryZh = target.productItemCategoryZh
          this.$set(this.currentRecordList[0], "fillStatus", 1)
        }
        /** 填充其他的中文品名 */
        this.excludeProductSkuList.forEach(item => {
          if (!item.productItemCategoryZh) {
            item.productItemCategoryZh = target.productItemCategoryZh
            this.$set(item, "fillStatus", 1)
          }
        })
        console.log(this.excludeProductSkuList);
        message.success('已填充中文品名')
      } else {
        message.warning('请选择中文品名')
      }
    },
    /** 获取批量编辑的参数列表 */
    getParamsList(list) {
      return list.map(item => {
        return {
          productSku: item.productSku,
          productItemCategoryZh: item.productItemCategoryZh,
          productCustomsId: this.productCategoryZhList.find((v) => v.productItemCategoryZh === item.productItemCategoryZh)?.productCustomsId
        }
      })
    },
    async handleOk() {
      const paramsList = [
        ...this.getParamsList(this.currentRecordList),
        ...this.getParamsList(this.excludeProductSkuList)
      ]
      this.confirmLoading = true
      const res = await batchUpdateProductItemCategoryZhApi(paramsList)
      this.confirmLoading = false
      message.success('保存成功')
      this.handleCancel()
      setTimeout(() => {
        this.$emit("submit", this.item, this.type);
      }, 1000)
    },
    handleCancel() {
      this.visible = false;
    },
    /** 一键删除 */
    handleOneClickDelete() {
      Modal.confirm({
        title: "提示",
        content: "是否一键删除",
        onOk: () => {
          this.currentRecordList[0].productItemCategoryZh = undefined
          this.$set(this.currentRecordList[0], "fillStatus", 0)
          this.excludeProductSkuList.forEach(item => {
            item.productItemCategoryZh = undefined
            this.$set(item, "fillStatus", 0)
          })
          message.success('操作成功！')
        }
      });
    }
  },
};
</script>

<style lang="less">
.edit-product-categoryZh {
  .ant-modal-mask {

    z-index: 4000;
  }

  .ant-modal-wrap {

    z-index: 4001;
  }

  .ant-modal-body {
    padding: 10px 16px;
    overflow-y: hidden;
  }

  .ant-select-dropdown {
    z-index: 4002 !important;
  }
}
</style>
